import React from 'react';
import { defineMessages } from 'react-intl';
import _ from 'lodash';
import { isTeacher, ssrRequest } from '../../../helpers';
import isLoggedIn from '../../../helpers/checkAuth';
import notAuthorized from '../../not-authorized';
import notFound from '../../not-found';
import QuizResult from './QuizResult';

import { getResult, resetResult } from '../../../actions/quizResult';
import { getQuiz } from '../../../actions/viewQuiz';
import {
  getCourseBySlug,
  reset as resetCourse,
} from '../../../actions/courseDetails';
import {
  getTaskWithCertificate,
  reset as resetTask,
} from '../../../actions/editGroupTask';
import ContextProvider from '../../../components/ContextProvider/ContextProvider';

const messages = defineMessages({
  quizResultTitle: {
    id: 'QuizResult.quizResultTitle',
    defaultMessage: 'Quiz Result: {name}',
    description: 'Title displayed on quiz result page',
  },
  examResultTitle: {
    id: 'QuizResult.examResultTitle',
    defaultMessage: 'Exam Result: {name}',
  },
  forbidden: {
    id: 'General.forbidden',
    defaultMessage: 'Forbidden',
  },
});

async function action(context) {
  const { store, params, fetch, query, intl } = context;
  const { courseSlug, quizId, taskId } = params;
  const { quizResultId } = context.query;

  const { auth } = store.getState();

  if (!isLoggedIn(auth)) {
    return notAuthorized(context);
  }

  await store.dispatch(resetCourse());
  if (courseSlug) {
    await ssrRequest({
      store,
      fetch,
      getAction: getCourseBySlug.bind(this, courseSlug),
      context,
    });
  }

  const { courseDetails } = store.getState();
  const courseId = _.get(courseDetails, 'course._id');

  const promises = [];

  promises.push(() =>
    ssrRequest({
      store,
      fetch,
      getAction: getQuiz.bind(this, quizId, { courseId }),
      context,
    }),
  );

  await store.dispatch(resetTask());
  if (taskId) {
    promises.push(() =>
      ssrRequest({
        store,
        fetch,
        getAction: getTaskWithCertificate.bind(this, taskId, { quizResultId }),
        context,
      }),
    );
  }

  promises.push(async () =>
    ssrRequest({
      store,
      fetch,
      getAction: getResult.bind(this, quizId, { taskId, quizResultId }),
      resetAction: resetResult,
      context,
    }),
  );

  const requests = await Promise.all(promises.map(promise => promise()));
  const notFoundReq = _.find(requests, item =>
    [403, 404].includes(_.get(item, 'status')),
  );

  if (notFoundReq) {
    return notFoundReq;
  }
  const { viewQuiz, quizResult } = store.getState();

  if (
    !isTeacher(auth) &&
    _.get(quizResult, 'quizResult.taskId') &&
    _.has(query, 'report') &&
    !_.get(viewQuiz, 'quiz.showReport')
  ) {
    return notFound({
      ...context,
      status: 403,
      title: intl.formatMessage(messages.forbidden),
    });
  }

  const title = taskId
    ? intl.formatMessage(messages.examResultTitle, {
        name: viewQuiz && _.get(viewQuiz, 'quiz.name', ''),
      })
    : intl.formatMessage(messages.quizResultTitle, {
        name: viewQuiz && _.get(viewQuiz, 'quiz.name', ''),
      });

  return {
    chunks: ['student-view-quiz'],
    title,
    component: (
      <ContextProvider context={context}>
        <QuizResult data={{}} title={title} query={query} />
      </ContextProvider>
    ),
  };
}

export default action;
